/**
 * @copyright Copyright (c) 2015, Pacific Biosciences of California, Inc.
 * @author <a href="mailto:bskinner@pacificbiosciences.com">Brian Skinner</a>
 */

import { Frame } from "../frames/frame"
import { commonTranslations } from "../translations/silos"
import { SchemaPropertyMap } from "../utils/legacy/i-schema-property"

export const ccsReadBaseProperties: SchemaPropertyMap = {
    name: {
        title: commonTranslations.name,
        description: "",
        type: "string",
        idField: "id"
    },
    wellSampleName: {
        title: commonTranslations.wellSampleName,
        description: "",
        type: "string"
    },
    bioSampleName: {
        title: commonTranslations.bioSampleName,
        description: "",
        type: "string"
    },
    dnaBarcodeName: {
        title: commonTranslations.dnaBarcodeName,
        description: "",
        type: "string"
    },
    cellIndex: {
        title: commonTranslations.cellIndex,
        description: "",
        type: "integer"
    },
    cellId: {
        title: commonTranslations.cellId,
        description: "",
        type: "string"
    },
    updatedAt: {
        title: commonTranslations.updatedAt,
        description: "",
        type: "string",
        format: "date-time"
    },
    numRecords: {
        title: commonTranslations.numSubreads,
        description: "",
        type: "integer"
    },
    totalLength: {
        title: commonTranslations.totalLengthSubreads,
        description: "",
        type: "integer"
    },
    createdAt: {
        title: commonTranslations.createdAt,
        description: "",
        type: "string",
        format: "date-time"
    },
    id: {
        title: commonTranslations.id,
        description: "",
        type: "string"
    },
    uuid: {
        title: commonTranslations.uuid,
        description: "",
        type: "string"
    },
    path: {
        title: commonTranslations.path,
        description: "",
        type: "string"
    },
    runName: {
        title: commonTranslations.runName,
        description: "",
        type: "string"
    },
    plateId: {
        title: commonTranslations.plateId,
        description: "",
        type: "string"
    },
    instrumentName: {
        title: commonTranslations.instrumentName,
        description: "",
        type: "string"
    },
    wellName: {
        title: commonTranslations.wellName,
        description: "",
        type: "string"
    },
    metadataContextId: {
        title: commonTranslations.metadataContextId,
        description: "",
        type: "string"
    },
    tags: {
        title: commonTranslations.tags,
        description: "",
        type: "string"
    },
    projectId: {
        title: commonTranslations.projectId,
        description: "",
        type: "integer"
    },
    jobId: {
        title: commonTranslations.jobId,
        description: "",
        type: "integer"
    },
    version: {
        title: commonTranslations.version,
        description: "",
        type: "string"
    },
    md5: {
        title: commonTranslations.md5,
        description: "",
        type: "string"
    },
    createdBy: {
        title: commonTranslations.createdBy,
        description: "",
        type: "string"
    },
    comments: {
        title: commonTranslations.comments,
        description: "",
        type: "string"
    }
}

const childProperty =  {
    numChildren: {
        title: commonTranslations.numChildren,
        description: "",
        type: "integer"
    }
}

const childCssReadProperties: SchemaPropertyMap = Object.assign({}, ccsReadBaseProperties)
const ccsReadProperties = Object.assign(childProperty, ccsReadBaseProperties)

export const CCS_READ_FRAME = new Frame({
    endpoint: undefined, // API.nDatasets.and({$set_type: "ccsreads"}),
    properties: ccsReadProperties
})


export const CHILD_CCS_READ_FRAME = new Frame({
    endpointFunction: undefined, /*(parentUuid: string) => API.nDatasets.and(
        {$set_type: "ccsreads", parentUuid: parentUuid, limit: MAX_RECORDS }) */
    properties: childCssReadProperties
})

export const PARENT_CCS_READ_FRAME = new Frame({
    endpoint: undefined, /* API.nDatasets.and({$set_type: "ccsreads", parentUuid: "null", limit: MAX_RECORDS}), */
    properties: ccsReadProperties
})

export const FLATTENED_CCS_READ_FRAME = new Frame({
    endpoint: undefined, /* API.nDatasets.and({$set_type: "ccsreads", limit: MAX_RECORDS}), */
    properties: ccsReadBaseProperties
})
